import { getDynamicText } from "/utils";
import { ProductBlocksDynamic_text } from "_types";
import { ReactProductState } from "product";
import { FC } from "react";
import { StoreApi, UseBoundStore } from "zustand";

export const ProductDynamicText: FC<{
  useProduct: UseBoundStore<StoreApi<ReactProductState>>;
  settings: ProductBlocksDynamic_text["settings"];
  content: string;
}> = ({ useProduct, settings, content }) => {
  const { product, selectedVariant } = useProduct(({ product, selectedVariant }) => ({
    product,
    selectedVariant,
  }));
  const data = {
    product,
    selectedVariant,
  };

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: getDynamicText(content, data),
      }}
    ></div>
  );
};
